// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__3X0wD","primary":"Label_primary__nZhHs","mustInput":"Label_mustInput__2qtzS"};